import React from "react";
import { useNavigate } from "react-router-dom";
import { createUser } from "../../../../api/adminClientApi";
import { Button } from "../../../../designSystem/button/Button";
import { Flex } from "../../../../designSystem/compositeComponents/FlexHelpers";
import { TextField } from "../../../../designSystem/formField/text/TextField";
import { MessageCard } from "../../../../designSystem/MessageCard";
import { Modal } from "../../../../designSystem/Modal";

type CreateUserModalProps = {
    show: boolean,
    onCreated: () => void,
    onCancel: () => void;
};
export function CreateUserModal (props: CreateUserModalProps): JSX.Element
{
    const navigate = useNavigate();
    const [email, setEmail] = React.useState('');
    const [password, setPassword] = React.useState('');
    const [message, setMessage] = React.useState('');

    React.useEffect(() =>
    {
        setEmail('');
        setPassword('');
        setMessage('');
    }, [props.show]);

    async function handleClickCreateUser ()
    {
        const result = await createUser(email, password, () => navigate(`/amorgy/login`));
        if (result)
            props.onCreated();
        else
            setMessage('Kunne ikke oprette brugeren');
    }

    return (

        <Modal
            title={"Opret bruger"}
            content={
                <Flex flexDirection="column" gap={16}>
                    {message &&
                        <MessageCard variant='warning'>
                            {message}
                        </MessageCard>
                    }
                    <CreateUserEditor
                        email={email}
                        password={password}
                        onEmailChange={setEmail}
                        onPasswordChange={setPassword}
                        onEnabledChange={() => { return; }}
                    />
                    <Flex flexDirection="row" justifyContent="space-between" gap={16}>
                        <Button variant="text" text='Annullér' onClick={props.onCancel} />
                        <Button variant="filled" text='Opret' onClick={handleClickCreateUser} />
                    </Flex>
                </Flex>
            }
            showModal={props.show}
            onCancel={props.onCancel} />
    );
}

type CreateUserEditorProps = {
    email: string,
    password: string,
    onEmailChange: (newValue: string) => void,
    onPasswordChange: (newValue: string) => void,
    onEnabledChange: (enabled: boolean) => void;
};
function CreateUserEditor (props: CreateUserEditorProps): JSX.Element
{
    return (
        <Flex flexDirection="column" gap={16}>
            <TextField
                label='E-mail'
                value={props.email}
                validator={() => ({ valid: true })}
                onChange={(value: string) => props.onEmailChange(value)}
            />
            <TextField
                label='Adgangskode'
                type='password'
                value={props.password}
                validator={() => ({ valid: true })}
                onChange={(value: string) => props.onPasswordChange(value)}
            />
        </Flex>
    );
}